'use strict';
import angular from 'angular';

angular.module('core.leads.ctrls', [])
    .controller('LeadsDashController', LeadsDashController);

/**
 * @ngInject
 */
function LeadsDashController(
    $scope,
    DataSourceType,
    AppFactory
) {
    var resetDateRange;

    function init() {
        $scope.$on('design:page:callback', function() {
            $scope.design.page.module = DataSourceType.LEADS;
            var compareDateRange = AppFactory.getComparisonDateRange();
            if (compareDateRange && compareDateRange.enabled) {
                AppFactory.toggleComparisonDateRange(false);
                resetDateRange = true;
            }
        });
        $scope.$on('$destroy', function() {
            resetDateRange && AppFactory.toggleComparisonDateRange(true);
        });
    }

    init();

}